var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramIdeas64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Ideas64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(16.000000, 5.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.815,42.9332734 C20.5136667,43.0102013 20.978,43.0051843 21.208,42.9182222 C27.028,40.746847 31,35.1869626 31,28.9287061 C31,20.7208276 24.222,14 16,14 C7.778,14 1,20.7208276 1,28.9287061 C1,35.2030171 4.99,40.7729357 10.832,42.9332734 C11.072,43.0222422 11.4606667,43.0222422 11.998,42.9332734 C14.3833333,42.9332734 15.7173333,42.9332734 16,42.9332734 C16.2826667,42.9332734 17.5543333,42.9332734 19.815,42.9332734 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFCC00",
    points: "11 43.004 21 43.004 21 52.004 11 52.004"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "11 44.5 11 31.5 16.06 37.522 21 31.5 21 44.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Emphasis",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 L16,7",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,5 L28,11",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5 L4,11",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramIdeas64);
export default __webpack_public_path__ + "static/media/pictogramIdeas64.92f048fa47d14b7c082d7d48cd5a3d71.svg";
export { ForwardRef as ReactComponent };